'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'bed-front';
var width = 512;
var height = 512;
var aliases = ["bed-alt"];
var unicode = 'f8f7';
var svgPathData = 'M40 32l-8 0 0 8 0 88 0 8 0 88L8 224l-8 0 0 8L0 408l0 64c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 480 0 0 56 0 8 16 0 0-8 0-64 0-176 0-8-8 0-24 0 0-88 0-8 0-88 0-8-8 0L40 32zm8 112l200 0 0 80L48 224l0-80zm200-16L48 128l0-80 416 0 0 80-200 0-8 0-8 0zm16 16l200 0 0 80-200 0 0-80zm0 96l200 0 16 0 16 0 0 160L16 400l0-160 16 0 16 0 200 0 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBedFront = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;